import React, { useState, createContext  } from 'react';
import './App.css';
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import './assets/css/bootstrap.min.css'
import './assets/css/animate.min.css'
import './assets/css/magnific-popup.css'
import './assets/fontawesome/css/all.min.css'
import './assets/css/dripicons.css'
import './assets/css/slick.css'
import './assets/css/meanmenu.css'
import './assets/css/default.css'
import './assets/css/style.css'
import './assets/css/responsive.css'

import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme, GlobalStyles } from './component/IITTP/global';

//siva
 import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// import './script';

// Create a context object
export const CountContext = createContext();

function App() {

  const [theme, setTheme] = useState('light');

  return (
  <CountContext.Provider value={{ theme, setTheme }}>
    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <>
        <GlobalStyles />
        <Router>
          <Routing />
        </Router>
      </>
      </ThemeProvider>
    </CountContext.Provider>
  );
}

export default App;
